export enum TermsLinks {
  EN = 'https://bkbn.com/terms-conditions',
  FR = 'https://bkbn.com/fr/conditions-generales',
  DE = 'https://bkbn.com/de/agb',
  ES = 'https://bkbn.com/es/terminos-y-condiciones',
  NL = 'https://bkbn.com/nl/algemene-voorwaarden',
  ALL_PURPOSE = 'https://bkbn.com/terms-conditions'
}

export enum CookiePolicyLinks {
  EN = 'https://bkbn.com/cookies-policy',
  FR = 'https://bkbn.com/fr/politique-cookies',
  DE = 'https://bkbn.com/de/cookie-richtlinie',
  ES = 'https://bkbn.com/es/politica-de-cookies',
  NL = 'https://bkbn.com/nl/cookiebeleid',
  ALL_PURPOSE = 'https://bkbn.com/cookies-policy'
}

export enum PrivacyPolicyLinks {
  EN = 'https://bkbn.com/privacy-policy',
  FR = 'https://bkbn.com/fr/politique-confidentialite',
  DE = 'https://bkbn.com/de/datenschutzerklaerung',
  ES = 'https://bkbn.com/es/politica-de-privacidad',
  NL = 'https://bkbn.com/nl/privacybeleid',
  ALL_PURPOSE = 'https://bkbn.com/privacy-policy'
}
